import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import SEPlayAddDialogListItem from './components/SEPlayAddDialogListItem';
import SEPlayListContainer from './components/SEPlayListContainer';
import { DialogImage, SEPlayDialogLabels } from './SEPlayTypes';
import Toolbar from '@mui/material/Toolbar';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';

type SEPlayDialogProps = {
    openEditSlideshow: boolean;
    onClose: () => void;
    images: DialogImage[];
    labels: SEPlayDialogLabels;
    handleAddImagesView: () => void;
    showAddImagesView: boolean;
    onCloseAddImagesView: () => void;
    handleUpdateImage: any;
    handleAddedImages: (images) => void;
};

export const SEPlayAddDialog = (props: SEPlayDialogProps) => {
    let { onClose, images, labels, handleAddedImages, showAddImagesView, onCloseAddImagesView } =
        props;

    const [addedImagesArray, setAddedImagesArray] = React.useState([]);

    const handleAddImage = (image) => {
        setAddedImagesArray((prev) => {
            return prev.concat([image]);
        });
    };

    const handleUncheckedImage = (image) => {
        setAddedImagesArray((current) =>
            current.filter((element) => element.reference !== image.reference)
        );
    };

    const handleClose = () => {
        if (addedImagesArray.length != 0) {
            handleAddedImages(addedImagesArray);
        }
        setAddedImagesArray([]);
    };

    const DoneButton = ({ label, onSubmit, onClose }) => {
        const handleOnClick = () => {
            onSubmit();
            onClose();
        };
        return (
            <Button
                aria-label="done-button"
                variant="contained"
                sx={{
                    borderRadius: '4px',
                    fontSize: '13px',
                    justifyItems: 'flex-end',
                    backgroundColor: '#4F7C6D'
                }}
                onClick={handleOnClick}
            >
                {label}
            </Button>
        );
    };

    return (
        <Dialog
            aria-label="slideshow-dialog"
            fullWidth={true}
            maxWidth="xl"
            margin={0}
            open={showAddImagesView}
            onClose={onClose}
        >
            <DialogContent sx={{ height: '90vh' }}>
                <Toolbar disableGutters={true} sx={{ paddingLeft: 0, paddingRight: 0, margin: 0 }}>
                    <DialogTitle variant="h4" sx={{ flex: 1, ml: 2, padding: 0, margin: 0 }}>
                        {labels.dialogTitle}
                    </DialogTitle>
                    <DoneButton
                        label={labels.dialogDoneButton}
                        onSubmit={handleClose}
                        onClose={onCloseAddImagesView}
                    />
                </Toolbar>
                <SEPlayListContainer>
                    {images.map((image, index) => {
                        if (image.includedInSlideshow === false) {
                            return (
                                <SEPlayAddDialogListItem
                                    key={image.index}
                                    image={image}
                                    handleAddImage={() => handleAddImage(image)}
                                    handleUncheckedImage={() => handleUncheckedImage(image)}
                                    addTooltipLabel={labels.addImageTooltip}
                                    removeTooltipLabel={labels.removeImageTooltip}
                                />
                            );
                        }
                    })}
                </SEPlayListContainer>
            </DialogContent>
        </Dialog>
    );
};

export default SEPlayAddDialog;